import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ODSService} from '../services/ods.service';
import {MatPaginator} from '@angular/material/paginator';
import * as backInter from 'app/auth/auth-data.model';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
interface Institutos {
  value: string;
  viewValue: string;
}

///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
export interface Institute {
  numInstituto: number;
  regionInstituto: string;
}

//Dialog RT
import { InfoRTComponent } from "app/main/pagina/tools/gestUsu/detail/info-rt/info-rt.component";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-consultar-requerimientos',
  templateUrl: './consultar-requerimientos.component.html',
  styleUrls: ['./consultar-requerimientos.component.scss']
})
export class ConsultarRequerimientosComponent implements OnInit {
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  cargando=false;
  descargado=false;
  datosTabla:any;
  skip:number;
  search='';
  institutoId:number;
  pagInicial:number;
  pagFinal:number;
  EncuestasMostrar=false;
  validacion:boolean=false;

  displayedColumns: string[] = ['nombre_de_empresa','fecha','tipoProducto','token','estatus','accion'];
  dataSource: MatTableDataSource<backInter.productosResultadoRT>;
  constructor(
    private _odsService: ODSService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    public dialog: MatDialog,
  ) {

    lang_perfiles.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.getInstituteArray();
    //this.getBanderasR(1);
  }
  institutes:any;
  public getInstituteArray() {
    this._odsService.getInstituteArray()
    .subscribe(response => {

     let result: Institute[] = response['Institutos'];
     result.sort( (a,b) => { if(a.numInstituto > b.numInstituto){ return 1; } else{ return -1; } });
     this.institutes = result;
     console.log(result);



    }, error => {
      console.log("error", error);
    })
  }

  validarInstituto(valor:number){
  this.institutoId=valor;
  this.getBanderasR(this.institutoId);
  if(valor>=1){
  this.validacion=true;
  }
  else{
  this.validacion=false;
  }
  }

   getBanderasR(institutoId:number) {
     let label1='CONSULTAR_RT.ELEMENTOS';
     let label2='CONSULTAR_RT.DE';
     let label3='CONSULTAR_RT.SIGUIENTE';
     let label4='CONSULTAR_RT.ULTIMA';
     let label5='CONSULTAR_RT.PRIMERA';
     let label6='CONSULTAR_RT.ANTERIOR';

     this.translateSrv.get(label1).subscribe((res: string) => { label1= res; });
     this.translateSrv.get(label2).subscribe((res: string) => { label2= res; });
     this.translateSrv.get(label3).subscribe((res: string) => { label3= res; });
     this.translateSrv.get(label4).subscribe((res: string) => { label4= res; });
     this.translateSrv.get(label5).subscribe((res: string) => { label5= res; });
     this.translateSrv.get(label6).subscribe((res: string) => { label6= res; });

     this.cargando = true;
    this._odsService.getBanderasReq(institutoId).subscribe((response:backInter.consultarRT) => {
      console.log('response',response);

      this.datosTabla=response;
      this.datosTabla.productos.forEach(productos => {
        if (productos.certificar.requerimientosv3.autentication==false && productos.certificar.requerimientosv3.requirements==false && productos.certificar.requerimientosv3.testAccess==false && productos.certificar.requerimientosv3.testEmail==false && productos.certificar.requerimientosv3.validationQ==false ) {
          productos.certificar.estatusReq= '0';
          productos.datosEmpresa.estatus= 'No iniciado';
        }else if (productos.certificar.requerimientosv3.autentication==true  && productos.certificar.requerimientosv3.testAccess==false && productos.certificar.requerimientosv3.testEmail==false && productos.certificar.requerimientosv3.validationQ==false && productos.certificar.requerimientosv3.requirements==false ) {
          productos.certificar.estatusReq= '1';
          productos.datosEmpresa.estatus= 'En proceso';
        }else if (productos.certificar.requerimientosv3.autentication==true && productos.certificar.requerimientosv3.testAccess==true && productos.certificar.requerimientosv3.testEmail==false && productos.certificar.requerimientosv3.validationQ==false && productos.certificar.requerimientosv3.requirements==false) {
          productos.certificar.estatusReq= '1';
          productos.datosEmpresa.estatus= 'En proceso';
        }else if (productos.certificar.requerimientosv3.autentication==true && productos.certificar.requerimientosv3.testAccess==true && productos.certificar.requerimientosv3.testEmail==false && productos.certificar.requerimientosv3.validationQ==false && productos.certificar.requerimientosv3.requirements==false) {
          productos.certificar.estatusReq= '1';
          productos.datosEmpresa.estatus= 'En proceso';
        }else if (productos.certificar.requerimientosv3.autentication==true && productos.certificar.requerimientosv3.testAccess==true && productos.certificar.requerimientosv3.testEmail==true && productos.certificar.requerimientosv3.validationQ==false && productos.certificar.requerimientosv3.requirements==false) {
          productos.certificar.estatusReq= '1';
          productos.datosEmpresa.estatus= 'En proceso';
        }else if (productos.certificar.requerimientosv3.autentication==true  && productos.certificar.requerimientosv3.testAccess==true && productos.certificar.requerimientosv3.testEmail==true && productos.certificar.requerimientosv3.validationQ==true  && productos.certificar.requerimientosv3.requirements==false) {
          productos.certificar.estatusReq= '1';
          productos.datosEmpresa.estatus= 'En proceso';
        }else if (productos.certificar.requerimientosv3.autentication==true  && productos.certificar.requerimientosv3.testAccess==true && productos.certificar.requerimientosv3.testEmail==true && productos.certificar.requerimientosv3.validationQ==true && productos.certificar.requerimientosv3.requirements==true) {
          productos.certificar.estatusReq= '2';
          productos.datosEmpresa.estatus= 'Terminado';
        }

        productos.datosEmpresa.token= productos.certificar.tokenConfig;
      });
console.log('this.datosTabla::',this.datosTabla);

      this.dataSource = new MatTableDataSource(response.productos);

      this.dataSource.filterPredicate = (data, filterValue: string)  => {
        const accumulator = (currentTerm, key) => {
          //console.log(data.datosEmpresa[key]);
          return key === 'productos' ? currentTerm : currentTerm + data.datosEmpresa[key] ;
        };
        const dataStr = Object.keys(data.datosEmpresa).reduce(accumulator, '').toLowerCase();
        // Transform the filterValue by converting it to lowercase and removing whitespace.
        const transformedFilter = filterValue.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) !== -1;
      }

      setTimeout(() => this.dataSource.paginator=this.paginator);
      setTimeout(() => this.paginator._intl.itemsPerPageLabel=label1);
      setTimeout(() => this.paginator._intl.nextPageLabel=label3);
      setTimeout(() => this.paginator._intl.lastPageLabel=label4);
      setTimeout(() => this.paginator._intl.firstPageLabel=label5);
      setTimeout(() => this.paginator._intl.previousPageLabel=label6);
      setTimeout(() => this.paginator._intl.getRangeLabel=(page: number, pageSize: number, length: number) => { if (length == 0 || pageSize == 0)
        { return `0 ${label2} ${length}`; } length = Math.max(length, 0); const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} – ${endIndex} ${label2} ${length}`; });

        this.cargando = false;

    }, error => {
      console.log("error", error);
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  verDetallesRT(idProducto:string, idEmpresa:string){
    const dialogRef = this.dialog.open(InfoRTComponent, {
      width: '75%',
      data: {
        empresaId: idEmpresa,
        productoId: idProducto
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
